module.exports = __webpack_public_path__ + "static/g10-339752eed29b2c69aef350de5661ee4b.jpg";